export default "/cars-for-sale/fordblueadvantage/accessibility-statement";